import React from 'react';

export default function WindowFrame({ children }) {
  return (
    <div className="w-full min-h-screen bg-[#180204] flex flex-col overflow-x-hidden text-[#FFF5E6]">
      {children}
    </div>
  );
}
